function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import MediaFrame from '../MediaFrame';
import LazyLoadedImage from './LazyLoadedImage';
import SmartVideo from './SmartVideo';
import Image from '../Image';
import Video from '../Video';
import { classNamesFor } from '../utils/classNames';
var cx; // const isImage = ({ src, type }) => {
//   const isImageFile = /(.jpg|.jpeg|.webp|.png|.gif)$/i.test(src);
//   const isBase64Image = /^data:image\/\w+;base64/.test(src);
//   return type === 'image' || isImageFile || isBase64Image;
// };
// const isVideo = ({ src, type }) => Video.player && Video.player.isVideo({ src, type });

/**
 * The Media component provides a high level interface for rendering and working with
 * images and videos in our UI. It is configured to lazy load images and videos only
 * show them only when the enter the screen. It allows setting aspect ratios so the UI
 * is aware of the space taken up by an image to avoid any jump in content.
 *
 * ## Composed of
 * - [LazyLoadedImage](./LazyLoadedImage/README.md)
 * - [SmartVideo](./SmartVideo/README.md)
 *
 * ## Related Components
 * - [VisibilitySensor](../VisibilitySensor/README.md)
 * - [Image](../Image/README.md)
 * - [Video](../Video/README.md)
 *
 * ## Usage
 *
 * ## Props
 *
 * For additional props see `SmartVideo` and `LazyLoadedImage`
 */

var Media = /*#__PURE__*/function (_PureComponent) {
  _inherits(Media, _PureComponent);

  var _super = _createSuper(Media);

  function Media() {
    _classCallCheck(this, Media);

    return _super.apply(this, arguments);
  }

  _createClass(Media, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          src = _this$props.src,
          type = _this$props.type,
          className = _this$props.className,
          debug = _this$props.debug;

      var _Media$getClassName = Media.getClassName({
        className: className
      }),
          root = _Media$getClassName.root;

      if (!src) return /*#__PURE__*/React.createElement(MediaFrame, _extends({}, this.props, {
        className: root
      }));

      if (Image.isImage({
        src: src,
        type: type
      })) {
        return /*#__PURE__*/React.createElement(LazyLoadedImage, _extends({}, this.props, {
          className: root
        }));
      }

      if (Video.isVideo({
        src: src,
        type: type
      })) {
        return /*#__PURE__*/React.createElement(SmartVideo, _extends({}, this.props, {
          className: root
        }));
      }

      return debug ? /*#__PURE__*/React.createElement("div", null, "Media not found ".concat(src)) : null;
    }
  }]);

  return Media;
}(PureComponent);

Media.defaultProps = {
  className: '',
  src: '',
  type: 'auto',
  width: undefined,
  debug: false
};
Media.propTypes = {
  /**
   * Allows adding a custom class or series of classes on the component
   * useful for setting margin or padding
   */
  className: PropTypes.string,

  /**
   * The source url or base64 string representing the media to display
   */
  src: PropTypes.string,

  /**
   * Type of media to load and display. Note for youtube and twitch
   * a player implementation will need to be provided. See `Configuration`
   * section for the `Video` component
   */
  type: PropTypes.oneOf(['auto', 'image', 'video', 'youtube', 'twitch']),

  /**
   * Sets the width of the frame
   */
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Whether to show unresolved media src in UI
   */
  debug: PropTypes.bool
};
Media.mediaFrame = true;

Media.getClassName = function (_ref) {
  var className = _ref.className;
  return {
    root: cx('psw-media', className)
  };
};

Media.useClassNames = function (classNames) {
  Media.classNames = classNames;
};

cx = classNamesFor(Media);
export default Media;